import { usePhoneMobileInputViewModel } from "../../viewmodel/usePhoneMobileInputViewModel";
import styles from "../PhoneVerification/PhoneVerificationPage.module.css";
import { Button } from "@/components/ui/Button";
import type { PhoneDialCode } from "@/features/auth/constants/phoneDialCodes";

export const PhoneMobileInputForm = () => {
  const {
    dialCode,
    setDialCode,
    nationalNumber,
    setNationalNumber,
    dialCodeOptions,
    handleSubmit,
    error,
  } = usePhoneMobileInputViewModel();

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        <div className={styles.infoBox}>Please enter your mobile number to continue.</div>

        <div className={styles.icon}>📱</div>

        <h2>Add Mobile Number</h2>
        <p className={styles.phoneFormSubtitle}>We’ll send a verification code to this number.</p>

        <div className={`${styles.phoneFieldGroup} ${error ? styles.phoneFieldGroupError : ""}`}>
          <select
            className={styles.dialSelect}
            value={dialCode}
            onChange={(e) => setDialCode(e.target.value as PhoneDialCode)}
            aria-label="Country dial code"
          >
            {dialCodeOptions.map((opt) => (
              <option key={opt.dialCode} value={opt.dialCode}>
                {opt.label}
              </option>
            ))}
          </select>
          <input
            className={styles.phoneNumberInput}
            value={nationalNumber}
            onChange={(e) => setNationalNumber(e.target.value)}
            placeholder="10-digit mobile number"
            type="tel"
            inputMode="numeric"
            autoComplete="off"
            aria-invalid={Boolean(error)}
            aria-describedby={error ? "phone-mobile-error" : undefined}
          />
        </div>
        {error && (
          <p id="phone-mobile-error" className={styles.error} role="alert">
            {error}
          </p>
        )}

        <Button className={styles.primaryBtn} onClick={handleSubmit}>
          Send OTP
        </Button>
      </div>
    </div>
  );
};
